var version = require("./version")

module.exports = isVirtualNode

function isVirtualNode(x) {
    return x && x.type === "VirtualNode" && x.version === version
}



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/vnode/is-vnode.js
// module id = 17
// module chunks = 0